
import {defineComponent} from 'vue';
import Button from "primevue/button";
import jsPDF from "jspdf";
import axios from "axios";
import {municipalityURL} from "@/config/app-settings";

export default defineComponent({
  name: "SpecimenLabelPrinter",
  components: {Button},
  data() {
    return {
      municipality: '',
      warningComment: false as Boolean
    }
  },
  props: {
    tableRow: {type: Object, required: true},
  },
  methods: {

    buildPDF(data: any) {
      // create pdf and add basic record information and user name
      let pdf = new jsPDF()

      pdf.setFont("arial")
      pdf.setFontSize(16)
      pdf.setTextColor(220, 220, 220); // grey
      pdf.text("Fungarium" + "  " + this.$store.getters.fullName, 60, 220)
      pdf.setTextColor(0, 0, 0); // black

      pdf.setFontSize(8)
      pdf.setFont("arial", "bold")
      pdf.text(data.TAXON_NAME , 60, 225)
      pdf.setFont("arial", "normal")

      pdf.text("SwissFungi-ID: " + data.RECORD_ID + (data.SPECIMEN_LABEL ? " | " + this.$t("specimenLabel.specimen") + data.SPECIMEN_LABEL : ''), 60, 230)

      pdf.text(this.$t("specimenLabel.locality"), 35, 235)
      pdf.text(this.municipality + (data.LOCALITY_DESCRIPTION ? " / " + data.LOCALITY_DESCRIPTION : ''), 60, 235)

      pdf.text(this.$t("specimenLabel.coordinates"), 35, 240)
      pdf.text(data.X + " / " + data.Y + (data.PRECISION_XY ? " +/- " + data.PRECISION_XY + "m" : ""), 60, 240)
      pdf.text(data.Z_MEASURED ? data.Z_MEASURED + " m.ü.M" : "", 120, 240)

      pdf.text(this.$t("specimenLabel.substrateCoarse"), 35, 245)
      pdf.text(data.SUBSTRATE ? data.SUBSTRATE_COARSE : "/", 60, 245)

      pdf.text(this.$t("specimenLabel.habitat"), 35, 250)
      pdf.text(data.DELARZE_HABITAT ? data.DELARZE_HABITAT : "/", 60, 250)

      pdf.text(this.$t("specimenLabel.substrateFine"), 35, 255)
      pdf.text((data.SUBSTRATE_FINE ? data.SUBSTRATE_FINE : "/") + (data.HOST_PLANT ? " (" + data.HOST_PLANT + ") " : ""), 60, 255)

      pdf.text(this.$t("specimenLabel.date"), 35, 260)
      pdf.text(data.RECORD_DATE, 60, 260)

      pdf.text(this.$t("specimenLabel.leg"), 60, 265)
      pdf.text(data.LEG, 80, 265)
      pdf.text(this.$t("specimenLabel.det"), 115, 265)
      pdf.text(data.DET ? data.DET : "/", 125, 265)

      pdf.text(this.$t("specimenLabel.comment"), 35, 280)
      pdf.setFontSize(5)
      if (data.COMMENT_RECORD && data.COMMENT_RECORD.length <= 130) {
        pdf.text(data.COMMENT_RECORD ? data.COMMENT_RECORD : "", 60, 280)
      } else if (data.COMMENT_RECORD && data.COMMENT_RECORD.length > 130) {
        this.$emit('warningComment')
      }
      pdf.setFontSize(8)
      pdf.save('herbar_' + this.$store.getters.fullName.toLowerCase().replace(" ", "_") + '.pdf')

    },
    printSpecimenLabel(data: any) {
      if (data.X && data.Y) {
        axios.get(municipalityURL + Math.round(parseInt(data.X)) + "/" + Math.round(parseInt(data.Y)))
            .then((res) => {
                  this.municipality = res.data
                  this.buildPDF(data)
                }
            ).catch(e =>
            console.log("could not generate PDF ", e)
        )
      }

    }
  }


})
